import {
    Image,
    List,
    Toast,
    Field,
    Form,
    Tab,
    Tabs,
    Card,
    Search,
    Skeleton,
    PullRefresh,
    Cell,
    Empty,
    Icon,
    Loading,
    Swipe,
    SwipeItem,
    Button,
    Popup,
    NavBar,
    RadioGroup,
    Radio,
    Picker,
    DatetimePicker,
    Area,
    Checkbox,
    Uploader,
    Progress,
    Tabbar,
    TabbarItem,
    Calendar,
    Notify,
    CellGroup,
    Cascader,
    Collapse,
    CollapseItem,
    TreeSelect,
    Dialog,
    DropdownMenu,
    DropdownItem,
    NoticeBar,
} from 'vant';
import { Dispatch } from 'vuex';

const vantPlugin = {
    install(Vue) {
        Toast.setDefaultOptions({ duration: 5000 });
        Vue.use(Image);
        Vue.use(List);
        Vue.use(Toast);
        Vue.use(Field);
        Vue.use(Form);
        Vue.use(Tab);
        Vue.use(Tabs);
        Vue.use(Card);
        Vue.use(Search);
        Vue.use(Skeleton);
        Vue.use(PullRefresh);
        Vue.use(Cell);
        Vue.use(Empty);
        Vue.use(Icon);
        Vue.use(Loading);
        Vue.use(Swipe);
        Vue.use(SwipeItem);
        Vue.use(Button);
        Vue.use(Popup);
        Vue.use(NavBar);
        Vue.use(RadioGroup);
        Vue.use(Radio);
        Vue.use(Picker);
        Vue.use(DatetimePicker);
        Vue.use(Area);
        Vue.use(Checkbox);
        Vue.use(Uploader);
        Vue.use(Progress);
        Vue.use(Tabbar);
        Vue.use(TabbarItem);
        Vue.use(Calendar);
        Vue.use(Notify);
        Vue.use(CellGroup);
        Vue.use(Cascader);
        Vue.use(Collapse);
        Vue.use(CollapseItem);
        Vue.use(TreeSelect);
        Vue.use(Dialog);
        Vue.use(DropdownMenu);
        Vue.use(DropdownItem);
        Vue.use(NoticeBar);
    },
};

export default vantPlugin;
